import { z } from 'zod';

export const MailModalSchema = z.object({
  emailComment: z.string(),
});
